<app-modal
  [(open)]="open"
  [title]="update.name"
  size="large"
  cancelLabel="Close"
  (closed)="onClose()"
>
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3 text-sm mb-6">
    <div>
      <p class="text-ink-2">Version</p>
      <p class="font-medium text-ink-1">{{ update.version }}</p>
    </div>
    <div>
      <p class="text-ink-2">Technology</p>
      <p class="font-medium text-ink-1">{{ update.displayTechnology }}</p>
    </div>
    <div>
      <p class="text-ink-2">Size</p>
      <p class="font-medium text-ink-1">{{ formatSize(update.size) }}</p>
    </div>
    <div>
      <p class="text-ink-2">Uploaded By</p>
      <p class="font-medium text-ink-1">{{ update.uploadedBy }}</p>
    </div>
    <div>
      <p class="text-ink-2">Original Filename</p>
      <p class="font-medium font-mono text-xs break-all text-ink-1">{{ update.originalFilename }}</p>
    </div>
    @if (update.checksum) {
      <div>
        <p class="text-ink-2">Checksum</p>
        <p class="font-medium font-mono text-xs break-all text-ink-1">{{ update.checksum }}</p>
      </div>
    }
    <div>
      <p class="text-ink-2">Created</p>
      <p class="font-medium text-ink-1">{{ update.createdAt | date:'medium' }}</p>
    </div>
    <div>
      <p class="text-ink-2">Updated</p>
      <p class="font-medium text-ink-1">{{ update.updatedAt | date:'medium' }}</p>
    </div>
    @if (update.description) {
      <div class="col-span-2">
        <p class="text-ink-2">Description</p>
        <p class="font-medium text-ink-1">{{ update.description }}</p>
      </div>
    }
  </div>
</app-modal>
